<template>
  <div>
    <div style="display: flex; flex-wrap: wrap; gap: 16px;">
      <div v-for="item in scoredFaceList" :key="item.faceimage" style="display: flex; flex-direction: column; align-items: center;">
        <img :src="item.faceimage"
             class="avatar"
             style="width:100px;height:100px">
        <div>{{item.face_score}}</div>
      </div>
    </div>
      <img v-if="image && scoredFaceList.length < 1"
           :src="image"
           class="avatar"
           style="width:100px;height:100px">
      <el-button type="primary"
                 size="mini" @click="displayPhotos">展示所有</el-button>

    <el-dialog
      title="人脸照片"
      :visible.sync="visible"
      width="50%"
      style="margin-left: 10px;">
        <template v-for="item in pic">
          <img :src="item" style="width: 200px;" @click="onViewImage">
        </template>
    </el-dialog>

  </div>

</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'
export default {
  components: {},
  props: {
    orderid: {
      type: Number,
      value: 0,
    },
    image: {
      type: String,
      value: '',
    },
    scoredFaceList: {
      type: Array,
      value: () => [],
    },
  },
  data () {
    return {
      visible: false,
      pic: []
    }
  },
  watch: {
  },

  methods: {
    displayPhotos () {
      let detail = {
        orderid: this.orderid,
      }
      request.common('getOrderFaceList', detail).then((res) => {
        this.pic = res.data
        if (res.data.length) {
          this.visible = true
        } else {
          this.$message('无人脸验证照片')
        }
      })
    },
    onViewImage (event) {
      if (!this.views) {
        this.views = new Viewer(event.target, {
          url: (image) => event.target.src,
        })
      }
      this.views.view()
    },
  },
}
</script>




// WEBPACK FOOTER //
// src/views/order/components/OrderFaceVerified.vue